import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserManagement.css';

const OWNER_EMAILS = ['phitaylr@gmail.com', 'ptaylor@students.randolphschool.net'];

function UserManagement({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {
    try {
      setLoading(true);
      console.log('UserManagement - Loading users...');
      console.log('UserManagement - Current user:', user);
      const response = await axios.get('/outcomes/api/users', { withCredentials: true });
      console.log('UserManagement - Users loaded successfully:', response.data);
      setUsers(response.data);
      setError(null);
    } catch (err) {
      console.error('UserManagement - Failed to load users:', err);
      console.error('UserManagement - Error status:', err.response?.status);
      console.error('UserManagement - Error data:', err.response?.data);
      console.error('UserManagement - Error message:', err.message);
      setError(err.response?.data?.error || 'Failed to load users. Only owner accounts can access this page.');
    } finally {
      setLoading(false);
    }
  };

  const toggleAdminStatus = async (userId, currentStatus, userEmail) => {
    // Prevent removing admin status from owner
    if (currentStatus && OWNER_EMAILS.includes(String(userEmail || '').toLowerCase())) {
      setError('Cannot remove admin status from owner');
      return;
    }

    try {
      const response = await axios.put(`/outcomes/api/users/${userId}/admin`, {
        is_admin: !currentStatus,
        email: userEmail
      }, { withCredentials: true });
      
      // Update the local state
      setUsers(users.map(u => 
        u.id === userId ? response.data : u
      ));
      setError(null);
    } catch (err) {
      console.error('Failed to update user:', err);
      setError(err.response?.data?.error || 'Failed to update user');
    }
  };

  if (loading) {
    return (
      <div className="user-management-container">
        <div className="loading">
          <div className="spinner"></div>
          <p>Loading users...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="user-management-container">
      <div className="user-management-header">
        <h2>User Management</h2>
        <p className="subtitle">Manage user permissions and admin status</p>
      </div>

      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      <div className="users-table-wrapper">
        <table className="users-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Joined</th>
              <th>Admin Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="5" className="no-users">
                  No users yet
                </td>
              </tr>
            ) : (
              users.map(u => (
                <tr key={u.id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{new Date(u.created_at).toLocaleDateString()}</td>
                  <td>
                    <span className={`admin-badge ${u.is_admin ? 'admin' : 'user'}`}>
                      {u.is_admin ? 'Admin' : 'User'}
                    </span>
                  </td>
                  <td>
                    {OWNER_EMAILS.includes(String(u.email || '').toLowerCase()) ? (
                      <span className="owner-badge">Owner</span>
                    ) : (
                      <button
                        className={`toggle-btn ${u.is_admin ? 'revoke' : 'grant'}`}
                        onClick={() => toggleAdminStatus(u.id, u.is_admin, u.email)}
                      >
                        {u.is_admin ? 'Revoke Admin' : 'Grant Admin'}
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserManagement;
